import { useProduct } from "./hooks/products/useProduct";
import HeaderComponent from "./components/HeaderComponent";
import StatsOverviewComponent from "./components/StatsOverviewComponent";
import ControlsSectionComponent from "./components/ControlsSectionComponent";
import ProductDisplayComponent from "./components/ProductDisplayComponent";
import TableViewComponent from "./components/TableViewComponent";
import EmptyStateComponent from "./components/EmptyStateComponent";
import FooterComponent from "./components/FooterComponent";
import applyRules from "./utils/applyRules";

function Dashboard() {

const {
    darkMode,
    toggleDarkMode,
    viewMode,
    setViewMode,
    filteredProducts,
    getStatusIcon,
    getStatusColor,
    getConfidenceColor,
    getProgressBarColor,
    getSalesIndicator,
    getStockIndicator,
    getPriceIndicator,
    containerVariants,
    itemVariants,
    stats,
    bgGradient,
    textColor,
    secondaryTextColor,
    cardBg,
    cardBorder,
    inputBg,
    inputBorder,
    buttonBg,
    buttonHoverBg,
    footerBorder,
    tableHeaderBg,
    tableRowBg,
    tableBorder,
    selectedStatus,
    setSelectedStatus,
    searchQuery,
    setSearchQuery,
  } = useProduct(applyRules);

  return (
    <div className={`min-h-screen ${bgGradient} ${textColor} p-4 md:p-8 transition-colors duration-500`}>
      {/* Header */}
      <HeaderComponent
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
        viewMode={viewMode}
        setViewMode={setViewMode}
        secondaryTextColor={secondaryTextColor}
      />

      {/* Stats Overview */}
      <StatsOverviewComponent
        stats={stats}
        darkMode={darkMode}
        secondaryTextColor={secondaryTextColor}
        cardBg={cardBg}
        cardBorder={cardBorder}
        containerVariants={containerVariants}
        itemVariants={itemVariants}
      />

      {/* Controls Section */}
      <ControlsSectionComponent
          darkMode={darkMode}
          setSelectedStatus={setSelectedStatus}
          selectedStatus={selectedStatus}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          cardBorder={cardBorder}
          buttonBg={buttonBg}
          buttonHoverBg={buttonHoverBg}
          inputBg={inputBg}
          inputBorder={inputBorder}
      />

      {/* Products Display - Cards View */}
      {viewMode === "cards" ? (
        <ProductDisplayComponent
            darkMode={darkMode}
            filteredProducts={filteredProducts}
            getStatusIcon={getStatusIcon}
            getStatusColor={getStatusColor}
            getConfidenceColor={getConfidenceColor}
            getProgressBarColor={getProgressBarColor}
            getSalesIndicator={getSalesIndicator}
            getStockIndicator={getStockIndicator}
            getPriceIndicator={getPriceIndicator}
            containerVariants={containerVariants}
            itemVariants={itemVariants}
            secondaryTextColor={secondaryTextColor}
            cardBorder={cardBorder}
        />
      ) : (
        <TableViewComponent
            darkMode={darkMode}
            filteredProducts={filteredProducts}
            getStatusColor={getStatusColor}
            getConfidenceColor={getConfidenceColor}
            getProgressBarColor={getProgressBarColor}
            getSalesIndicator={getSalesIndicator}
            getStockIndicator={getStockIndicator}
            tableBorder={tableBorder}
            tableHeaderBg={tableHeaderBg}
            tableRowBg={tableRowBg}
        />
      )}

      {/* Empty State */}
      <EmptyStateComponent
          darkMode={darkMode}
          filteredProducts={filteredProducts}
          secondaryTextColor={secondaryTextColor}
      />

      <FooterComponent
        darkMode={darkMode}
        stats={stats}
        footerBorder={footerBorder}
        secondaryTextColor={secondaryTextColor}
      />

    </div>
  );
}

export default Dashboard;